'use strict';

/**
 * Match NavBlock Tiles
 */
function matchNavBlockTiles() {
    var $pdNavBlocks = $('.pd-nav-block');

    if ($pdNavBlocks.length) {
        $pdNavBlocks.each(function () {
            var editMode = $(this).find('.row-links').data('editmode');
            var numTiles = $(this).find('.row-links').data('numtiles');
            var maxTiles = $(this).find('.row-links').data('maxtiles');

            if (numTiles <= 2) {
                $(this).find('.region.row-links').addClass('justify-content-md-center');
            }

            $(this).find('.nav-block-tile picture').matchHeight({ byRow: false });

            if (maxTiles && !editMode && $('.view-all-nav').length > 0) {
                $(this).find('.nav-block-tile:gt(' + (maxTiles - 1) + ')').addClass('js-hidden');
            }

            $(this).find('.view-all-nav').on('click', function () {
                $(this).parents('.pd-nav-block').find('.nav-block-tile').removeClass('js-hidden');
                $(this).remove();
            });
        });
    }
}

/**
 * Wait for lazyload to finish before matching tile heights
 */
function awaitLazyloadThenMatchTileHeight() {
    var navBlockImages = $('.nav-block-tile picture img');
    if (navBlockImages.hasClass('lazyloading')) {
        var checkPictures = setInterval(function () {
            if (!navBlockImages.hasClass('lazyloading')) {
                clearInterval(checkPictures);
                matchNavBlockTiles();
            }
        }, 100);
    } else {
        matchNavBlockTiles();
    }
}

$(document).ready(function () {
    awaitLazyloadThenMatchTileHeight();
});

$(window).smartresize(function () {
    matchNavBlockTiles();
});
